import React from 'react';
import { FlameIcon } from 'lucide-react';

// Barra que aparece casi llena: quedan pocos cupos al precio promocional.
const SPOTS_LEFT = 9;
const FILLED_PERCENT = 91;
export function ScarcityBar() {
  return <div className="mx-auto max-w-md rounded-2xl border border-mauve/30 bg-mauve-soft/30 p-4" data-id="element-211" data-mp="2l44twfdh6ne6">
      <div className="flex items-center justify-between text-sm font-bold text-plum" data-id="element-212" data-mp="2q2zdvkn6ihzv">
        <span className="flex items-center gap-1.5" data-id="element-213" data-mp="2b6gwfhohj1sb">
          <FlameIcon className="h-4 w-4 text-mauve" data-id="element-214" data-mp="2b9355kn43nc4" />
          Cupos al precio promocional
        </span>
        <span className="text-mauve" data-id="element-215" data-mp="2g3gvv9qtx6ag">Quedan {SPOTS_LEFT}</span>
      </div>
      <div className="mt-2.5 h-3 w-full overflow-hidden rounded-full bg-white" data-id="element-216" data-mp="227wlx3t2vyf6">
        <div className="h-full rounded-full bg-mauve transition-all" style={{
        width: `${FILLED_PERCENT}%`
      }} data-id="element-217" data-mp="275y5rqybw1rp" />
      </div>
      <p className="mt-2 text-center text-xs font-semibold text-plum/70" data-id="element-218" data-mp="5drzyhk31ylf">
        ¡Casi agotados! Reserva el tuyo antes de que suba el precio.
      </p>
    </div>;
}